<app-top-navigation [class.blackGradient]="videoPlay"></app-top-navigation>
<div class="mainContainer">
	<div class="container-fluid">
		<div class="row">
			<div class="col-3">
				<div class="sideBar">
					<div class="step text-center" style="position: absolute;z-index: 5;width: 70%;height: 97%;background: #ffffff85;"
						 *ngIf="flowLoading">
						<div class="loader-block">
							<svg id="loader2" viewBox="0 0 100 100">
								<circle _ngcontent-hug-c166="" id="circle-loader2" cx="50" cy="50" r="45"></circle>
							</svg>
						</div>
						<div style="top: 29rem;position: absolute;left: 39%;">LOADING....</div>
					</div>
					<div class="mapView">
						<img src="https://a.cdn-hotels.com/kesstatic/97312c5fefe8fc8f82c0.svg" />
						<button class="mapViewButton">Map view</button>
					</div>
					<ng-container *ngIf="$cities | async as cities">
						<div class="popularFilters moduleContainer">
							<label>Περιοχή</label>
							<ng-select [items]="cities" groupBy="group" bindLabel="name" placeholder="Select a city" [multiple]="true"
									   [maxSelectedItems]="10" [closeOnSelect]="false" (close)="regionFilter()"
									   [(ngModel)]="selectedCities"></ng-select>
						</div>
					</ng-container>
					<ng-container>
						<div class="popularFilters moduleContainer">
							<label>Περίοδος</label>
							<form class="form-inline">
								<div class="form-group hidden">
									<div class="input-group">
										<input name="datepicker"
											   class="form-control"
											   ngbDatepicker
											   #datepicker="ngbDatepicker"
											   [autoClose]="'outside'"
											   (dateSelect)="onDateSelection($event)"
											   [displayMonths]="2"
											   [dayTemplate]="t"
											   outsideDays="hidden"
											   [startDate]="fromDate!"
											   tabindex="-1"
											   readonly
												style="visibility: hidden;margin-top: -26px;">
										<ng-template #t let-date let-focused="focused">
											<span class="custom-day"
												  [class.focused]="focused"
												  [class.range]="isRange(date)"
												  [class.faded]="isHovered(date) || isInside(date)"
												  (mouseenter)="hoveredDate = date"
												  (mouseleave)="hoveredDate = null">
											  {{ date.day }}
											</span>
										</ng-template>
									</div>
								</div>
								<div class="form-group">
									<div class="input-group">
										<input #dpFromDate
											   class="form-control" placeholder="yyyy-mm-dd"
											   name="dpFromDate"
											   readonly
											   [value]="formatter.format(fromDate)"
											   (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
											   (click)="datepicker.open()">
									</div>
								</div>
								<div class="form-group ml-2">
									<div class="input-group">
										<input #dpToDate
											   class="form-control" placeholder="yyyy-mm-dd"
											   name="dpToDate"
											   readonly
											   [value]="formatter.format(toDate)"
											   (input)="toDate = validateInput(toDate, dpToDate.value)"
											   (click)="datepicker.open()">
									</div>
								</div>
							</form>
						</div>
					</ng-container>
					<div class="priceRange moduleContainer">
						<label>Διάρκεια σε λεπτά</label>
						<ngx-slider [(value)]="lowDuration" [(highValue)]="highDuration" [options]="options"
									(userChangeEnd)="durationFilter($event)"></ngx-slider>
					</div>
					<ng-container *ngIf="$sites | async as sites">
						<div class="popularFilters moduleContainer">
							<label>Τοποθεσία ή χώρος</label>
							<ul>
								<li *ngFor="let site of sites">
									<input id="checkbox-site-{{site.id}}" type="checkbox" name="site-{{site.id}}[]"
										   [value]="site.id" (change)="siteFilter(site.id)" [checked]="checkedSite(site.id)" />
									<label for="checkbox-site-{{site.id}}">
										<span>{{this.globalDataService.getObjectTranslation(site.siteTranslations, "name")}}</span>
									</label>
								</li>
							</ul>
						</div>
					</ng-container>
					<div class="priceRange moduleContainer">
						<label>Εύρος τιμής</label>
						<ngx-slider [(value)]="lowValue" [(highValue)]="highValue" [options]="options"
									(userChangeEnd)="priceFilter($event)"></ngx-slider>
					</div>
					<div class="popularFilters moduleContainer" *ngFor="let filters of extraFilters">
						<label>{{this.globalDataService.getObjectTranslation(filters[0].attribute.attributeTranslations, "name")}}</label>
						<ul>
							<li *ngFor="let value of filters">
								<input id="checkbox-{{value.value}}-{{value.id}}" type="checkbox" name="{{value.attribute.code}}[]"
									   [value]="value.value" (change)="filterChange(value)" [checked]="checkedFilter(value)" />
								<label for="checkbox-{{value.value}}-{{value.id}}">
									<span>{{this.globalDataService.getObjectTranslation(value.attributeValueTranslations, "name")}}</span>
								</label>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="col-9">
				<div class="sectionContainer">
					<h3 class="locationTitle">Αποτελέσματα αναζήτησης {{filteredResults.length}} από {{filteredResults.length}}</h3>
					<div class="row">
						<div class="col-12">
							Sort By :
							<div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
								<button class="btn btn-outline-primary mr-2" id="dropdownManual" ngbDropdownToggle>Duration</button>
								<div ngbDropdownMenu aria-labelledby="dropdownManual">
									<button ngbDropdownItem>Long 40 min</button>
									<button ngbDropdownItem>Short 20 min</button>
								</div>
							</div>
							<button class="btn btn-outline-primary mr-2">Featured</button>
							<div class="d-inline-block" ngbDropdown #myDrop2="ngbDropdown">
								<button class="btn btn-outline-primary mr-2" id="dropdownManual2" ngbDropdownToggle>Price</button>
								<div ngbDropdownMenu aria-labelledby="dropdownManual">
									<button ngbDropdownItem>Ascending (Low to High Price)</button>
									<button ngbDropdownItem>Descending (High to Low Price)</button>
								</div>
							</div>
						</div>
					</div>
					<div class="cultureContainer topContainer">
						<div class="step text-center" style="margin-top: 100px;position: relative" *ngIf="flowLoading">
							<div class="loader-block" style="top: 25px;">
								<svg id="loader2" viewBox="0 0 100 100">
									<circle id="circle-loader2" cx="50" cy="50" r="45"></circle>
								</svg>
							</div>
							<div>LOADING....</div>
						</div>
						<ng-container *ngFor="let route of filteredResults">
							<div class="row cultureRoute" *ngIf="!flowLoading">
								<div class="col-3">
									<div class="owner">
										<div class="owner-thumb" [style.background-image]="'url('+route.user.image+')'"></div>
									</div>
									<figure>
										<img [src]="route.image">
									</figure>
								</div>
								<div class="col-7">
									<h4>{{this.globalDataService.getObjectTranslation(route.culturalRouteTranslations, "title")}}</h4>
									<div class="information">
										{{this.globalDataService.getObjectTranslation(route.culturalRouteTranslations, "description")}}
									</div>
									<div class="tagsInfo">
										<ul>
											<li *ngFor="let attributeValue of route.attributeValues">
												{{this.globalDataService.getObjectTranslation(attributeValue.attributeValueTranslations, "name")}}
											</li>
										</ul>
									</div>
									<div class="availability mt-1">
										<a href="javascript:void(0)" (click)="route.availabilitiesToggle = !route.availabilitiesToggle">
											{{'TRANS_CULTUREVR.AVAILABILITY_CALENDAR' |translate}}
										</a>
									</div>
								</div>
								<div class="col-2">
									<div class="guided">
										<span class="price">From 30&euro;</span>
										<button class="booknow">Book now</button>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-3"></div>
								<div class="col-8 availabilityCalendar" style="text-align: center">
									<div [ngbCollapse]="route.availabilitiesToggle">
										<div class="card">
											<div class="card-body">
												<ngb-datepicker [displayMonths]="3" [showWeekNumbers]="false" [dayTemplate]="customDay"
												></ngb-datepicker>
												<ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected"
															 let-disabled="disabled" let-focused="focused">
													  <span class="custom-day" [class.focused]="focused"
															(click)="openDayPopup(date, route.availabilities)"
															[class.text-muted]="disabled ||
															!isAvailable(date,route.availabilities)"
															[class.disabled]="!isAvailable(date,route.availabilities)">
														{{ date.day }}
													  </span>
												</ng-template>
											</div>
										</div>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="footerInfo">
		<div class="row">
			<div class="col-3">
				<label>Information</label>
				<ul>
					<li>How it works</li>
					<li>News</li>
					<li>Our guide partners</li>
				</ul>
			</div>
			<div class="col-3">
				<label>Guides</label>
				<ul>
					<li>Become a partner</li>
					<li>Guide list</li>
					<li>What you need to know</li>
				</ul>
			</div>
			<div class="col-3">
				<label>Policies</label>
				<ul>
					<li>Terms</li>
					<li>Privacy Policy</li>
				</ul>
			</div>
			<div class="col-3">
				<img src="assets/images/cards/visa.png" style="width: 39px;margin-right: 11px;">
				<img src="assets/images/cards/mastercard.png" style="width: 41px;margin-right: 9px;">
				<img src="assets/images/cards/diners.png" style="margin-right: 10px;width: 92px;">
				<img src="assets/images/cards/discover.png" style="width: 52px;"> <br />
				<label>
					Powered By
					<span style="width: 92%;">
						<img src="assets/images/cards/everypay.png" style="width: 93px;">
					</span>
				</label>
			</div>
			<div class="col-12" style="font-size: .7rem;margin-top: 10px;">
				COPYRIGHT © 2021 CULTUREAPP. ALL RIGHTS RESERVED
			</div>
		</div>
	</div>
</div>
<ng-template #rt let-r="result" let-t="term">
	<div class="row searchResutl">
		<div class="col-2 icon">
			<fa-icon [icon]="['fas','map-marker-alt']"></fa-icon>
		</div>
		<div class="col-10 results">
			<ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
			<div class="subTitle">{{r.country}}, {{r.region}}, {{r.state}}</div>
		</div>
	</div>
</ng-template>
<ng-template #content let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Κυριακή 12/11/2021</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<form>
			<div class="form-group">
				<label>Επιλέξτε μία απο τις παρακάτω διαθέσιμες ώρες </label>
				<div class="input-group tableAvailability">
					<table>
						<thead>
							<tr>
								<th>Έναρξη</th>
								<th>Λήξη</th>
								<th>&euro; ανα άτομο</th>
								<th>Απομένουν</th>
								<th>Επιλεγμένο</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let availability of modalAvailabilities">
								<td>{{getTime(availability.dateTimeStart)}}</td>
								<td>{{getTime(availability.dateTimeEnd)}}</td>
								<td>{{availability.pricePerPerson}}&euro;</td>
								<td>{{availability.occupiedSeats}} απο {{availability.maxPersons}}</td>
								<th><input type="radio" name="availability" (change)="selectedAvailability = availability" /></th>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-dark" (click)="modal.dismiss('Close click')">Close</button>
		<button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Book Now</button>
	</div>
</ng-template>